<script setup>
import { ref, onMounted, useSSRContext } from 'vue'
import { useToast } from 'primevue/usetoast'
import axios from 'axios'
import { FilterMatchMode } from 'primevue/api'
import { useConfirm } from "primevue/useconfirm"
/////////////////////
// Interface Props //
/////////////////////
const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()
// filters
const filter_stock = ref({'global': {value: null, matchMode: FilterMatchMode.CONTAINS}})
//////////////////
// Data Sources //
//////////////////
const stock = ref()

const get_base_data = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + "/sula/get-stock")
        .then(response => {
            stock.value = response.data
        }).catch(error => {
        console.error("There was an error!", error.message);
    })
}
onMounted(() => {
    get_base_data()
})
const format_currency = (value) => {
    return Number(value).toLocaleString('de-CH', {style: 'currency', currency: 'CHF', minimumFractionDigits: 2});
}
const format_swiss_date = (value) => {
    return value.substring(8,10) + '.' + value.substring(5,7) + '.' + value.substring(0,4)
}

const openSulaWorldProduct = (permalink) => {
    window.open(permalink,'_blank')
}

const openBexioProduct = (id) => {
    window.open('https://office.bexio.com/index.php/artikel/show/id/' + String(id),'_blank')
}

const openWooCommerceProduct = (id) => {
    window.open('https://sulaworld.com/wp-admin/edit.php?s=' + String(id) + '&post_status=all&post_type=product&seo_filter&readability_filter&product_cat&product_type&stock_status&fb_sync_enabled&paged=1','_blank')
}

</script>

<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>

<template>
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <ProgressSpinner v-if="loader" style="width:50px;height:50px" strokeWidth="8" animationDuration="1.5s" aria-label="Custom ProgressSpinner" class="spinner" />
    <BlockUI :fullScreen="true" :blocked="loader">
        <div class="col-12 mb-2">
            <Toolbar>
                <template #start>
                    <span class="p-input-icon-left mr-3">
                        <i class="pi pi-search" />
                        <InputText v-model="filter_stock['global'].value" placeholder="Suche" style="width: 300px" />
                    </span>
                    <Button label="Sync Stock" icon="pi pi-refresh" class="p-button mr-2" />
                </template>
                <template #end>
                </template>
            </Toolbar>
        </div>
        <DataTable v-model:filters="filter_stock" :value="stock" :rows="20" responsiveLayout="scroll" :rowHover="true" :rowsPerPageOptions="[20,50,100]" :paginator="true"  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
            <Column field="name_bexio" header="Produkt" sortable>
                <template #body="slotProps">
                    <Avatar icon="pi pi-tag" class="mr-2" style="backgroundColor:var(--primary-500); color:var(--surface-0)"  shape="circle" />
                    {{slotProps.data.name_bexio}}
                </template>
            </Column>
            <Column field="sku" header="SKU" sortable>
                <template #body="slotProps">
                    {{slotProps.data.sku}}
                </template>
            </Column>
            <Column header="Stock Bexio" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.stock_bexio }}
                </template>
            </Column>
            <Column header="Stock WC" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.stock_woocommerce }}
                </template>
            </Column>
            <Column header="Betrag" sortable>
                <template #body="slotProps">
                    {{format_currency(slotProps.data.total)}}
                </template>
            </Column>
            <Column field="id" header="">
                <template #body="slotProps">
                    <Button v-if="slotProps.data.permalink" label="Sula" @click="openSulaWorldProduct(slotProps.data.permalink)" class="mr-2 p-button w-auto" style="background-color: #000; color: #FFF; border: 1px solid #000" icon="pi pi-external-link" />
                    <Button label="Bexio" @click="openBexioProduct(slotProps.data.id_bexio)" class="mr-2 p-button w-auto" style="background-color: #0d2f3b; color: #bbdc00; border: 1px solid #bbdc00" icon="pi pi-external-link" />
                    <Button v-if="slotProps.data.id_woocommerce" label="WooCommerce" @click="openWooCommerceProduct(slotProps.data.id_woocommerce)" class="mr-2 p-button w-auto" style="background-color: #9B5C8F; color: #FFF; border: 1px solid #9B5C8F" icon="pi pi-external-link" />
                </template>
            </Column>
        </DataTable>
    </BlockUI>
    <!--------------------------------------------------->
    <!------------------- Dialogs ----------------------->
    <!--------------------------------------------------->
</template>